export default "__VITE_ASSET__J4SBuhHb__";